/**
 * STATUSES ALLOWED ONLY when userProcess.mode === "MOS"
 */
export const UserProcessStatus_MOS = {
  /**
   * ### Status set by system (MOS 1+2)
   * - (MOS 1+2) AFTER the consultant confirms: "I have reviewed the personal-data and documents"
   * - (MOS 1+2) AND AFTER checklist have been generated succesfully.
   * ### Requirements
   * - `userProcess.mode === "MOS"`
   * - AND `userProcess.hasAssistantService === false && userProcess.hasFullHandling === false`
   * - OR `userProcess.hasAssistantService === true && userProcess.hasFullHandling === false`
   * ### What Foreigner sees:
   *  - Information about APPOINTMENT:
   *    - If not setup yet - ask to pick the type (in-office / online) and DATE for the appointment (this appointment is only for consultant to verify documents and application overall)
   *    - If already setup - date, type, place, info about the appointment and the whole process of negotiating appointment date with the office(conultant)
   *  - Informations that BEFORE the appointment he's supposed to DO ALL things in:
   *    - instructions how setup PZ (Profil Zaufany) and MOS account
   *    - instructions how to submit the documents via MOS
   *  - Less important needed later:
   *    - option to print list of required documents (checklist) that will be needed for the voivo-office (immigration office) visit later
   *  - option to upload documents for final-review
   */
  APPOINTMENT_TO_VERIFY_DOCS: 'APPOINTMENT_TO_VERIFY_DOCS',

  /**
   * ### Status set by system (MOS 3 only)
   * - (MOS 3) AFTER the consultant confirms: "I have reviewed the personal-data and documents"
   * - (MOS 3) AND AFTER MAIN_REQ_DOC and STATEMENTS and CHECKLIST have been generated succesfully.
   * ### Requirements
   * - `userProcess.mode === "MOS"` AND `userProcess.hasFullHandling === true`
   * ### What Foreigner sees:
   *  - Information about APPOINTMENT:
   *    - If not setup yet - ask to pick the type (in-office / online) and DATE for the appointment (this appointment is to SUBMIT APPLICATION TO MOS WITH OUR CONSULTANT)
   *    - If already setup - date, type, place, info about the appointment and the whole process of negotiating appointment date with the office(conultant)
   *  - Informations that BEFORE the appointment he's supposed to DO ALL things in:
   *    - instructions how setup PZ (Profil Zaufany) and MOS account
   *  - Less important needed later:
   *    - option to print list of required documents (checklist) that will be needed for the voivo-office (immigration office) visit later
   *    - option to print PoA
   *  - Option to upload documents for final-review
   */
  APPOINTMENT_TO_SUBMIT_TO_MOS: 'APPOINTMENT_TO_SUBMIT_TO_MOS',

  /**
   * ### Status set by system (MOS 1 only)
   * - (MOS 1) AFTER the consultant completes the appointment (APPOINTMENT_COMPLETED) in APPOINTMENT_TO_VERIFY_DOCS
   * ### Requirements
   * - Only for user-processes with `userProcess.mode === "MOS"`
   * - Only with LEVEL 1 `userProcess.hasAssistantService === false && userProcess.hasFullHandling === false`
   * ### What Foreigner sees:
   *  - instructions how setup PZ (Profil Zaufany) and MOS account
   *  - instructions how to submit the documents via MOS
   *  - option to upload documents for final-review
   * ### This is the end of the process for such user-processes (MOS 1)
   */
  REVIEW_DONE_MOS_SUBMISSION_INSTRUCTIONS: 'REVIEW_DONE_MOS_SUBMISSION_INSTRUCTIONS',
} as const;

export type UserProcessStatus_MOS = (typeof UserProcessStatus_MOS)[keyof typeof UserProcessStatus_MOS];
